import axios from 'axios';

export const HttpCodes = {
    Success: {
        Ok: 200,
        Created: 201,
        Accepted: 202,
        NoContent: 204,
    },
    Redirect: {
        Permanent: 301,
        Found: 302,
    },
    ClientError: {
        BadRequest: 400,
        Unauthorized: 401,
        Forbidden: 403,
        NotFound: 404,
        Unprocessable: 422,
        Timeout: 429,
    },
};

axios.defaults.withCredentials = true;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export default axios;
